import { OnboardingStep, OnboardingStepType } from '../types/onboarding-steps';

export const ONBOARDING_STEPS: Record<OnboardingStepType, OnboardingStep> = {
  applied: {
    id: 'applied',
    title: '1. Meet your hiring pipeline',
    step: 1,
    content:
      'All your candidates will appear here - ready for review or to move onto another stage.',
    elementSelector: '[data-rh-onboarding="applied"]',
    position: 'bottom',
  },
  'customize-test': {
    id: 'customize-test',
    title: '2. Customize tests & interviews',
    step: 2,
    content:
      'Easily add skills tests, interviews, or other stages to match your hiring process.',
    elementSelector: '[data-rh-onboarding="customize-test"]',
    position: 'bottom',
  },
  automation: {
    id: 'automation',
    title: '3. Automate your pipeline',
    step: 3,
    content:
      'Set up automations to handle repetitive tasks and keep your pipeline flowing.',
    elementSelector: '[data-rh-onboarding="automation"]',
    position: 'top',
  },
  'careers-page': {
    id: 'careers-page',
    title: '4. Publish your careers page',
    step: 4,
    content:
      'When you’re ready, add the job to your careers page and start hiring!',
    elementSelector: '[data-rh-onboarding="careers-page"]',
    position: 'right',
  },
};
